import i18n from "../../localization/i18n";
import { TelegramAuthStatus } from "src/app/channel/channel-main/channel-list/channel-item/enums/TelegramAuthStatus";

export const _getQrStatusMessage = (status: string): { text: string } => {
    switch (status) {
        case TelegramAuthStatus.WaitingForScan:
            return { text: i18n.t('qr.telegram.scanCode')};

        case TelegramAuthStatus.Authorized:
            return { text: i18n.t('qr.telegram.authorized')};

        case TelegramAuthStatus.Initializing:
            return { text: i18n.t('qr.telegram.initializing')};

        case TelegramAuthStatus.EmptySettings:
            return { text: i18n.t('qr.telegram.emptySettings')};

        case TelegramAuthStatus.StartChannel:
            return { text: i18n.t('qr.telegram.startChannel')};

        case TelegramAuthStatus.RequiresPassword:
            return { text: i18n.t('qr.telegram.requiresPassword')};

        case TelegramAuthStatus.RequiresManualInput:
            return { text: i18n.t('qr.telegram.requiresManualInput') };

        case TelegramAuthStatus.Error:
        default:
            return { text: status || i18n.t('error.error')};
    }
};